var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"outlined":""}},[_vm._v(" 本日の次回予約: "+_vm._s(_vm.isLoading ? '...' : _vm.count)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }